// @flow
// 存储页面打开后不会变化的信息，这部分信息不需要存在 redux 中，也不需要通过 props 传递

import type { Marketplace, Platform, Visitor } from './type'

import { codeToPlatform, isValidPlatform } from '../lib/platform'

type Query = { [string]: string };

type PageInfo = {
  visitor: Visitor,

  code: string,
  version: string,
  query: Query,
  platform: Platform,
  marketplace: Marketplace,
  beginDate: string,
  endDate: string,

  // 服务器时间和本地时间间隔
  offsetTime: number,

  // used in editor
  readonly: boolean,
  title: string,
  projectId: ?string,

  // 编辑器信息
  editorMode?: 'page' | 'complexComp'
};

let pageInfo: PageInfo

export function initPageInfo (info: $Subtype<PageInfo>) {
  pageInfo = {
    ...info,
    offsetTime: new Date(info.serverTime).getTime() - new Date().getTime(),
    platform: isValidPlatform(info.platform)
      ? info.platform
      : codeToPlatform(info.code)
  }
}

export function setVersion (version: string) {
  pageInfo.version = version
}

export function setEditorMode (editorMode: 'page' | 'complexComp') {
  pageInfo.editorMode = editorMode
}

export function isInComplexCompEditor (): boolean {
  return pageInfo.editorMode === 'complexComp'
}

export function isInEditor (): boolean {
  return !!pageInfo.editorMode
}

export function getPageInfo (): PageInfo {
  return pageInfo
}

export function getQuery (): Query {
  return pageInfo.query
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/pageInfo.js